import createAction from './_createAction';

const BASKET_TOGGLE_CHECK_SINGLE = createAction('BASKET_TOGGLE_CHECK_SINGLE');

export default BASKET_TOGGLE_CHECK_SINGLE;
